module.exports = __webpack_public_path__ + "static/cyclorama2-99a2841bba594fcb7b769c3dfd99596e.jpg";